import React from "react";
import NewsroomMediaTwo from "../component/NewsroomMediaTwo";

function NewsroomMediaTwoContainer() {
  return <NewsroomMediaTwo />;
}

export default NewsroomMediaTwoContainer;
